import React from 'react';
import { motion } from 'framer-motion';
import { Gem, Leaf, Zap, Clock, Heart, CheckCircle2 } from 'lucide-react';
export function TanningSection() {
  return <section id="tanning" className="py-24 px-6 bg-cream border-t border-gold/10" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-229">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-gold font-sans text-sm md:text-base uppercase tracking-[0.3em] mb-4 font-semibold" data-id="element-230">
            Nuevo Servicio
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl font-serif text-ink-dark" data-id="element-231">
            Bronceado Inteligente con Prosun V3 42
          </motion.h2>
        </div>

        {/* Content Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-232">
          {/* Left Column: Text Content */}
          <div className="space-y-10" data-id="element-233">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="font-sans text-lg text-ink-light leading-relaxed" data-id="element-234">
              Logra un tono dorado, uniforme y saludable durante todo el año con
              nuestra tecnología de bronceado de última generación. Trabajamos
              con la exclusiva Prosun V3 42, una máquina vertical de alto
              rendimiento diseñada para brindar resultados rápidos, seguros y
              naturales, adaptándose a cada tipo de piel.
            </motion.p>

            <div className="space-y-8" data-id="element-235">
              {/* Feature 1 */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} data-id="element-236">
                <h3 className="flex items-center gap-3 font-serif text-2xl text-ink mb-3" data-id="element-237">
                  <Gem className="text-gold" size={24} data-id="element-238" />
                  ¿Qué hace especial este servicio?
                </h3>
                <p className="font-sans text-ink-light pl-9" data-id="element-239">
                  La Prosun V3 42 cuenta con 42 lámparas de alta eficiencia que
                  permiten un bronceado homogéneo en menos tiempo, optimizando
                  cada sesión para que obtengas el color deseado sin
                  sobreexposición.
                </p>
              </motion.div>

              {/* Feature 2 */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.4
            }} data-id="element-240">
                <h3 className="flex items-center gap-3 font-serif text-2xl text-ink mb-4" data-id="element-241">
                  <Leaf className="text-gold" size={24} data-id="element-242" />
                  Beneficios del servicio
                </h3>
                <ul className="space-y-2 pl-9 font-sans text-ink-light" data-id="element-243">
                  {['Bronceado uniforme y sin marcas', 'Resultados visibles desde las primeras sesiones', 'Sesiones rápidas y eficientes', 'Mayor higiene gracias a su formato vertical', 'Sensación de bienestar y energía'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-244">
                      <CheckCircle2 className="text-gold/60 shrink-0 mt-1" size={16} data-id="element-245" />
                      <span data-id="element-246">{item}</span>
                    </li>)}
                </ul>
              </motion.div>

              {/* Feature 3 */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.5
            }} data-id="element-247">
                <h3 className="flex items-center gap-3 font-serif text-2xl text-ink mb-3" data-id="element-248">
                  <Zap className="text-gold" size={24} data-id="element-249" />
                  Experiencia personalizada
                </h3>
                <p className="font-sans text-ink-light pl-9" data-id="element-250">
                  Antes de cada sesión, evaluamos tu tipo de piel para
                  recomendarte el tiempo adecuado, cuidando siempre tu salud y
                  potenciando los resultados.
                </p>
              </motion.div>

              {/* Feature 4 */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.6
            }} data-id="element-251">
                <h3 className="flex items-center gap-3 font-serif text-2xl text-ink mb-3" data-id="element-252">
                  <Clock className="text-gold" size={24} data-id="element-253" />
                  Duración de la sesión
                </h3>
                <p className="font-sans text-ink-light pl-9" data-id="element-254">
                  Entre 6 y 10 minutos, según tu fototipo y objetivo de
                  bronceado.
                </p>
              </motion.div>

              {/* Feature 5 */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.7
            }} data-id="element-255">
                <h3 className="flex items-center gap-3 font-serif text-2xl text-ink mb-4" data-id="element-256">
                  <Heart className="text-gold" size={24} data-id="element-257" />
                  Ideal para ti si quieres:
                </h3>
                <ul className="space-y-2 pl-9 font-sans text-ink-light" data-id="element-258">
                  {['Verte radiante sin exposición prolongada al sol', 'Preparar tu piel para eventos o vacaciones', 'Mantener un bronceado natural todo el año'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-259">
                      <CheckCircle2 className="text-gold/60 shrink-0 mt-1" size={16} data-id="element-260" />
                      <span data-id="element-261">{item}</span>
                    </li>)}
                </ul>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} className="mt-12 p-6 bg-blush/20 border-l-4 border-gold rounded-r-sm" data-id="element-262">
              <p className="font-serif text-xl md:text-2xl text-ink-dark italic" data-id="element-263">
                "Conviértete en tu mejor versión, con una piel luminosa y un
                bronceado que realza tu energía."
              </p>
            </motion.div>
          </div>

          {/* Right Column: Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative h-full min-h-[600px] lg:min-h-full rounded-sm overflow-hidden shadow-xl border border-gold/10" data-id="element-264">
            <img src="https://cdn.magicpatterns.com/uploads/iNkUwswbGjKe4rRq3MgpNr/WhatsApp_Image_2026-05-01_at_8.56.17_PM.jpg" alt="Bronceado Inteligente" className="absolute inset-0 w-full h-full object-cover" data-id="element-265" />
            {/* Subtle overlay for elegance */}
            <div className="absolute inset-0 bg-gradient-to-t from-ink/20 to-transparent pointer-events-none" data-id="element-266" />
          </motion.div>
        </div>
      </div>
    </section>;
}